module.exports = __webpack_public_path__ + "static/media/04-lose.63244315.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructiongifs/04-lose.gif
// module id = 261
// module chunks = 0